var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(_vm.compiledData, { tag: "component", attrs: { code: _vm.code } })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }